import {
  Drawer,
  Row,
  Col,
  Image,
  Typography,
  Space,
  Button,
  Empty,
  Tag,
  Badge,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { DeleteFilled } from "@ant-design/icons";
import { removeItem } from "../../redux/slices/cartSlice";
import { useNavigate } from "react-router-dom";
const { Paragraph, Text } = Typography;
function CartDrawer({ openCart, handleClose }) {
  const cart = useSelector((state) => state.cart.value);
  const navigate = useNavigate();
  let lineTotal = 0;
  cart &&
    cart.forEach((x) => {
      lineTotal += x.price;
    });
  const dispatch = useDispatch();
  return (
    <Drawer
      open={openCart}
      onClose={handleClose}
      title="Catalogue"
      footer={
        <Space key="foot" size={30}>
          <Button
            type="primary"
            onClick={() => {
              navigate("/checkout");
              handleClose();
            }}
          >
            Continue to Checkout
          </Button>
          <Button> TOTAL : $ {lineTotal?.toLocaleString()}</Button>
        </Space>
      }
    >
      {cart.length < 1 ? (
        <Empty description="No Items selected!!!" />
      ) : (
        <>
          {" "}
          {cart.map((item) => {
            return (
              <div key={item.key} className="cart-item">
                <Badge.Ribbon
                  text={item.packageName}
                  color={
                    item.packageName === "Standard"
                      ? "pink"
                      : item.packageName === "Premium"
                      ? "cyan"
                      : "volcano"
                  }
                >
                  <Row
                    align="middle"
                    gutter={12}
                    style={{ paddingRight: "0.5rem" }}
                  >
                    <Col span={6}>
                      <Image
                        src={item.images[0]}
                        style={{ height: "100%" }}
                        preview={false}
                      />
                    </Col>
                    <Col span={18}>
                      <Paragraph
                        style={{
                          fontSize: "14px",
                          color: "#0c6f8d",
                          margin: "0.1rem 0",
                        }}
                      >
                        {item.title}
                      </Paragraph>
                      <Paragraph
                        ellipsis={{
                          rows: 2,
                          expandable: false,
                        }}
                        style={{
                          fontSize: "12px",
                          color: "#888",
                          padding: "0.3rem 0",
                          margin: 0,
                        }}
                      >
                        {item.description}
                      </Paragraph>
                      <Row align="middle">
                        <Col span={12}>
                          <Paragraph
                            style={{
                              fontSize: "14px",
                              color: "#000",
                              margin: 0,
                            }}
                          >
                            Price:{" "}
                            <Text strong style={{ color: "#E83209" }}>
                              $ {item.price?.toLocaleString()}{" "}
                            </Text>
                          </Paragraph>
                        </Col>
                        <Col span={12} style={{ textAlign: "right" }}>
                          <DeleteFilled
                            style={{ color: "#E83209" }}
                            onClick={() =>
                              dispatch(removeItem({ key: item.key }))
                            }
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Badge.Ribbon>
              </div>
            );
          })}
        </>
      )}
    </Drawer>
  );
}

export default CartDrawer;
